module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-topic",
      "name": "hres32e-topic"
    }
  }, [_c('div', {
    staticClass: "main-topic-box"
  }, [_c('i', {
    staticClass: "left-arrow fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowLeft()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-topic",
    on: {
      "click": function($event) {
        _vm.toggleMenuMobile()
      }
    }
  }, [_vm._v(_vm._s(_vm.nameTopic(_vm.page)))]), _vm._v(" "), _c('i', {
    staticClass: "right-arrow fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowRight()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page === 2),
      expression: "page === 2"
    }],
    staticClass: "main-topic-box-lv2"
  }, [_c('i', {
    staticClass: "left-arrow fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowSubLeft()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-topic-lv2"
  }, [_vm._v(_vm._s(_vm.nameSubTopic(_vm.subPage)))]), _vm._v(" "), _c('i', {
    staticClass: "right-arrow fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowSubRight()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-050310e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/topic.vue
// module id = 3514
// module chunks = 1